import React from "react";
import { sendEmailVerification, signOut } from "firebase/auth";
import { auth, EMAIL_VERIFICATION_ACS } from "../firebase";

export default function VerifyEmailPanel(): JSX.Element {
  const [isSending, setIsSending] = React.useState(false);
  const [feedback, setFeedback] = React.useState<string | null>(null);

  const resendEmail = async () => {
    const user = auth.currentUser;
    if (!user) return;
    setIsSending(true);
    setFeedback(null);
    try {
      await sendEmailVerification(user, EMAIL_VERIFICATION_ACS);
      setFeedback("Ny länk skickad. Kolla din inkorg.");
    } catch (e: any) {
      setFeedback(`Fel: ${e?.message || "Kunde inte skicka länk."}`);
    } finally {
      setIsSending(false);
    }
  };

  const handleSignOut = async () => {
    try {
      await signOut(auth);
    } catch (e) {
      console.warn("signOut failed", e);
    }
    window.location.href = "/";
  };

  return (
    <div style={{ maxWidth: 520, margin: "48px auto", padding: 16, border: "1px solid var(--border)", borderRadius: 12 }}>
      <h2 style={{ marginTop: 0 }}>Verifiera din e-post</h2>
      <p>
        Vi har skickat ett mejl med en verifieringslänk. Öppna mejlet och klicka på länken.
        När det är klart kommer denna sida att uppdateras automatiskt.
      </p>
      <div style={{ display: "flex", gap: 8, marginTop: 12, flexWrap: "wrap" }}>
        <button type="button" onClick={resendEmail} className="btn btn-outline" disabled={isSending}>
          {isSending ? "Skickar..." : "Skicka om e-post"}
        </button>
        <button type="button" className="btn btn-secondary" onClick={handleSignOut} disabled={isSending}>
          Logga ut / Byt konto
        </button>
      </div>
      {feedback && <div style={{ marginTop: 10, fontSize: 13 }}>{feedback}</div>}
    </div>
  );
}
